import React, { useState } from "react";
import { AddIcon, DeleteIcon, MinusIcon } from "@chakra-ui/icons";
import {
  Box,
  Checkbox,
  HStack,
  IconButton,
  Input,
  SimpleGrid,
  Text,
  useMediaQuery,
  VStack,
} from "@chakra-ui/react";
import DeleteCart from "../modals/DeleteCart";
import axios from "axios";

function PostData(seller_id, item_id, qty) {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const url = "/carts";

  axios
    .post(
      baseURL + url,
      {
        seller_id: seller_id,
        item_id: item_id,
        qty: qty,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    )
    .then((res) => {
      console.log(res);
    })
    .catch((e) => {
      console.log(e);
    });
}
async function PutData(seller_id, id, item_id, qty) {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const url = "/carts/" + id;

  return await axios
    .put(
      baseURL + url,
      {
        seller_id: seller_id,
        item_id: item_id,
        qty: qty,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      }
    )
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((e) => {
      console.log(e);
      return e;
    });
}

export default function ListCart({
  id,
  img,
  name,
  price,
  quantity,
  checkedItem,
  handleChecked,
  sellerId,
  itemId,
  setQuantity,
  handleReload,
}) {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const [open, setOpen] = useState(false);
  const [jumlah, setJumlah] = useState(quantity);

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const handleChangeAdd = () => {
    // setJumlah(parseInt(jumlah) + 1);
    let jml = jumlah + 1;
    PutData(sellerId, id, itemId, jml).then(() => {
      handleReload();
    });
  };
  const handleChangeEdit = (e) => {
    console.log(e.target.value);
    setJumlah(parseInt(e.target.value));
    PutData(sellerId, id, itemId, parseInt(e.target.value));
  };
  const handleChangeMin = () => {
    let jml = jumlah - 1;
    PutData(sellerId, id, itemId, jml).then(() => {
      handleReload();
    });
  };

  const handleCloseDelete = () => {
    setOpen(false);
  };
  const handleDelete = () => {
    axios
      .delete(baseURL + "/carts/" + id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        handleReload();
        console.log(res);
      })
      .catch((e) => console.log(e));
  };
  return (
    <Box display="flex" py="10">
      <Box px="3" display="flex" alignContent="center">
        <Checkbox
          isChecked={checkedItem}
          onChange={(e) => handleChecked(e, id)}
        />
      </Box>
      <img
        src={img}
        alt="items"
        style={{
          border: "1px solid #E0E0E0",
          borderRadius: "10px",
          maxWidth: mobile ? "150px" : "200px",
          maxHeight: mobile ? "150px" : "200px",
        }}
      />
      <SimpleGrid w="full" columns={mobile ? 1 : 2}>
        <VStack
          w="full"
          align="baseline"
          justifyContent="center"
          spacing={2}
          px="3"
        >
          <Text fontWeight="500" fontSize="20px">
            {name}
          </Text>
          <Text color="#B9B9B9">{jumlah} barang</Text>
          <Text fontWeight="600" fontSize="16px">
            {IDRConvert.format(price)}
          </Text>
        </VStack>
        <Box
          display="flex"
          alignItems="center"
          justifyContent={!mobile && "end"}
        >
          <IconButton variant="ghost" onClick={() => setOpen(true)}>
            <DeleteIcon />
          </IconButton>
          <HStack spacing="0" border="1px solid #E0E0E0">
            <IconButton
              disabled={jumlah <= 1 ? true : false}
              variant="ghost"
              borderRightRadius="0px"
              onClick={handleChangeMin}
            >
              <MinusIcon />
            </IconButton>
            <Input
              p="2"
              minW="9"
              maxW="14"
              margin="0 auto"
              variant="unstyled"
              borderRadius="0px"
              type="number"
              disabled
              value={jumlah}
              onChange={handleChangeEdit}
            ></Input>
            <IconButton
              variant="ghost"
              borderLeftRadius="0px"
              onClick={handleChangeAdd}
            >
              <AddIcon />
            </IconButton>
          </HStack>
        </Box>
      </SimpleGrid>
      <DeleteCart
        isOpen={open}
        onClose={handleCloseDelete}
        name={name}
        img={img}
        qty={jumlah}
        handleDelete={handleDelete}
      />
    </Box>
  );
}
